/**
 * Утилиты ввода кода (work-020).
 *
 * Browser-safe: импортирует только из @veylme/shared (без node:crypto).
 * Алфавит и длина берутся из CODE_CONFIG — изменение конфига автоматически
 * подхватывается нормализацией и валидацией без правки этого файла.
 */
import { CODE_CONFIG, codeSchema } from '@veylme/shared';

/**
 * Нормализует сырой ввод пользователя: оставляет только символы из
 * CODE_CONFIG.alphabet и обрезает до CODE_CONFIG.length.
 *
 * Фильтрация по alphabet.includes(ch) — намеренно, а не regex `\d`,
 * чтобы пережить будущие расширения алфавита (буквы, etc.).
 */
export function normalizeCodeInput(raw: string): string {
  let result = '';
  for (const ch of raw) {
    if (CODE_CONFIG.alphabet.includes(ch)) {
      result += ch;
      if (result.length === CODE_CONFIG.length) break;
    }
  }
  return result;
}

/**
 * Проверяет, является ли строка полным валидным кодом (ровно CODE_CONFIG.length
 * символов из CODE_CONFIG.alphabet). Использует codeSchema из @veylme/shared
 * — единая точка валидации (CANON SP1).
 */
export function isCompleteCode(s: string): boolean {
  return codeSchema.safeParse(s).success;
}
